module.exports = __webpack_public_path__ + "media/honey-icons/icon-battery-empty-c10df455.svg";